//#region src/utils/commonModels/customerAddress.ts
var e = {
	BILLING: "BILLING",
	SHIPPING: "SHIPPING"
}, t = (t) => t?.find(({ purposes: t }) => t.includes(e.BILLING))?.address ?? null, n = (t) => t?.find(({ purposes: t }) => t.includes(e.SHIPPING))?.address ?? null, r = (t) => !!t?.some(({ purposes: t }) => t.includes(e.BILLING) && t.includes(e.SHIPPING)), i = (t) => t ? [{
	purposes: [e.BILLING],
	address: t
}] : [], a = ({ billingAddress: t, shippingAddress: n, isShippingSameAsBilling: r }) => r ? t ? [{
	purposes: [e.BILLING, e.SHIPPING],
	address: t
}] : [] : [...i(t), ...n ? [{
	purposes: [e.SHIPPING],
	address: n
}] : []], o = {
	BILLING: "BILLING",
	SHIPPING: "SHIPPING"
}, s = (e) => l(e, o.BILLING), c = (e) => l(e, o.SHIPPING), l = (e, t) => {
	let n = e?.find(({ purposes: e }) => e.includes(t));
	return n ? {
		name: n.name,
		email: n.email
	} : null;
};
//#endregion
export { e as CUSTOMER_ADDRESS_PURPOSES, o as CUSTOMER_CONTACT_PURPOSES, t as getBillingAddress, s as getBillingContact, n as getShippingAddress, c as getShippingContact, r as isShippingSameAsBilling, i as toBillingOnlyAddresses, a as toCustomerAddresses };

//# sourceMappingURL=index.js.map